import React from "react";
import { Dialog } from "primereact/dialog";
import { BRAND_BASE_URL } from "../../services/BaseURL";

const ImageView = ({
  setViewImage,
  viewImage,
  viewImageData,
  mobileNumber,
  customerFirstName,
  customerLastName,
  invoiceNo,
  orderNo,
}) => {
  const handleModalClose = () => {
    setViewImage(false);
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={viewImage}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!viewImage) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
               
            >
              
                <div>
                  <div
                    onClick={() => setViewImage(false)}
                    style={{
                      cursor:"pointer",
                      position: "absolute",
                      right: 10,
                      top: 8,
                      backgroundColor: "#c2c2c2",
                      borderRadius: 50,
                      height: 30,
                      width: 30,
                      zIndex: 9,
                    }}
                  >
                    <p className="text-xl font-bold  text-center" >X</p>
                  </div>
                  <p className="text-xl font-normal text-center my-2">{viewImageData.imageName}</p>
                  <div className="flex justify-content-center align-items-center my-2"
                  >
                    <img
                      // src={viewImageData.tagImageUrl}
                      src={BRAND_BASE_URL + "/store/api/external/v1/order-tag-image-by-code/" + viewImageData.imageCode}
                      style={{ width: "50%", height: "50%" }}
                    />
                  </div>

                  <p className="text-xl font-normal">
                    {customerFirstName + " " + customerLastName} -{" "}
                    {mobileNumber}
                  </p>

                  <p className="text-xl font-normal">Order No. : {orderNo}</p>
                  <p className="text-xl font-normal">Bill No. : {invoiceNo}</p>
                </div>
              </div>
            </div>
           
        )}
      ></Dialog>
    </div>
  );
};

export default ImageView;
